import React from "react";

import CheckListSvg from "../../assets/images/icons/Form Controls/Checkbox List.svg";

export const CheckboxListIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={CheckListSvg}
        alt={alt || "Check List"}
    />
);
